import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/zh1';
export const locale = {
  lang: 'zh1',
  data: {
    'VOICE': {
      'ENABLE': '啟用音軌進行調查',
      'TITULO': '語音設置',
      'SUBTITULO': '僅當啟用了調查的音軌時，才會應用此設置。',
      'CONFIG_IDIOMA': {
        'TITULO': '此語言的當前設置',
        'GENERO': {
          'TITULO': '聲音性別',
          'Femenino': '女性',
          'Masculino': '男性'
        },
        'TIPO_VOZ': {
          'TITULO': '語音類型',
          '1': '聲音類型 1',
          '2': '語音類型 2',
          '3': '聲音類型 3',
          '4': '語音類型 4',
          '5': '語音類型 5',
          '6': '語音類型 6',
          '7': '語音類型 7',
          '8': '語音類型 8',
          '9': '語音類型 9',
          '10': '聲音類型 10',
        },
        'PRUEBA_VOZ': {
          'TITULO': '語音測試',
          'INSTRUCCION': '寫一段文字來測試聲音',
          'PLACEHOLDER': '語音測試文本',
          'PROBAR': '測試文本到語音'
        }
      },
      'MODALES': {
        'COMPLETAR': '您確定使用當前的語音選擇完成了該步驟嗎？',
        'COMPLETAR_OFF': '您確定要在禁用語音設置的情況下完成該步驟嗎？',
        'INCOMPLETO': '您還沒有對所有語言的聲音進行完整選擇，需要完成它才能繼續',
        'PASO_COMPLETO': '步驟成功完成',
        'GENERANDO_AUDIOS': '語音設置正在應用到此產品的部分，請稍等'
      }
    }
  }
};
